import { apiWeb, tokenStore } from './api';
import { jwtDecode } from 'jwt-decode';
/**
 * POST /Login/LoginFromCodigoCotizador?codigoCotizacion=xxxxx
 * Respuesta: { token: "..." }
 */
export async function loginFromCodigoCotizador(codigoCotizacion) {
    const codigo = String(codigoCotizacion ?? '').trim();
    if (!codigo)
        throw new Error('El código es obligatorio.');
    try {
        const { data } = await apiWeb.post(`/Login/LoginFromCodigoCotizador`, null, {
            params: { codigoCotizacion: codigo }
        });
        if (!data?.token)
            throw new Error('La API no devolvió token.');
        tokenStore.set(data.token);
        return data.token;
    }
    catch (err) {
        const status = err?.response?.status;
        const message = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Error al validar el código.';
        if (status === 401 || status === 403) {
            throw new Error('Código incorrecto o sin permisos.');
        }
        throw new Error(message);
    }
}
export function getToken() {
    return tokenStore.get();
}
export function setToken(token) {
    tokenStore.set(token);
}
export function removeToken() {
    tokenStore.clear();
}
export function getTokenPayload() {
    const token = getToken();
    if (!token)
        return null;
    try {
        return jwtDecode(token);
    }
    catch (e) {
        return null;
    }
}
export function isTokenValid() {
    const payload = getTokenPayload();
    if (!payload || !payload.exp)
        return false;
    const now = Date.now() / 1000;
    return payload.exp > now;
}
export function getCurrentUser() {
    const payload = getTokenPayload();
    return payload ? payload.usuario || payload.nombre || payload.email || payload.sub : null;
}
// ── Leer claim permisoEmitir del JWT ───────────────────────────────
export function getJwtClaim(claimKey) {
    try {
        // Ajusta la clave de almacenamiento según tu implementación
        const token = localStorage.getItem('token') ??
            localStorage.getItem('access_token') ??
            localStorage.getItem('jwt_token') ??
            sessionStorage.getItem('token') ??
            sessionStorage.getItem('access_token') ??
            sessionStorage.getItem('jwt_token');
        if (!token)
            return null;
        const parts = token.split('.');
        if (parts.length !== 3)
            return null;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload[claimKey] ?? null;
    }
    catch {
        return null;
    }
}
export function isAdministrador() {
    const payload = getTokenPayload();
    if (!payload)
        return false;
    const superAdmin = payload.superAdmin;
    return superAdmin === true || String(superAdmin).toLowerCase() === 'true' || Number(superAdmin) === 1;
}
export function hasDefaultVigenciaInicio() {
    const payload = getTokenPayload();
    if (!payload)
        return false;
    const superAdmin = payload.superAdmin;
    return superAdmin === true || String(superAdmin).toLowerCase() === 'true' || Number(superAdmin) === 1;
}
export function logout() {
    tokenStore.clear();
    window.location.href = '/#/';
}
export default {
    loginFromCodigoCotizador,
    getToken,
    setToken,
    removeToken,
    getTokenPayload,
    isTokenValid,
    getCurrentUser,
    isAdministrador,
    logout
};
